import React, {useCallback, useRef} from "react";
import NiceModal, {NiceModalHocProps, useModal} from "@ebay/nice-modal-react";
import {useLocation} from "react-router-dom";
import {useUpdateEffect} from "react-use";
import {NoticeDialog} from "./NoticeDialog";
import {ButtonTypes} from "../../../../ui";

interface AreYouSureDialogProps extends NiceModalHocProps {
  onConfirm: (x: boolean) => void;
  onCancel?: () => void;
  headerTextId?: string;
  contentTextId?: string;
  confirmTextId: string;
  secondaryText?: string;
  confirmButtonType?: ButtonTypes;
}

const AreYouSureDialog = NiceModal.create(
  ({onConfirm, headerTextId, contentTextId, confirmTextId, secondaryText, onCancel}: AreYouSureDialogProps) => {
    const modal = useModal();
    const {pathname} = useLocation();
    const resolvedRef = useRef(false);

    const confirmHandler = useCallback((): void => {
      resolvedRef.current = true;
      onConfirm(true);
      modal.resolve(true);
      modal.hide();
    }, [onConfirm, modal]);

    const cancelHandler = useCallback((): void => {
      if (resolvedRef.current) return;
      onCancel?.();
      modal.resolve(false);
      modal.hide();
    }, [modal, onCancel]);

    useUpdateEffect(() => {
      cancelHandler();
    }, [pathname]);

    return (
      <NoticeDialog
        title={headerTextId || "Are You Sure?"}
        buttonText={confirmTextId}
        onClose={cancelHandler}
        onClick={confirmHandler}
        secondaryButtonText={secondaryText ?? "Cancel"}
        text={contentTextId}
        onClickSecondary={cancelHandler}
        isError
      />
    );
  }
);

export default AreYouSureDialog;
